export function safeReturnTarget(raw: string | null | undefined): string | null {
  if (!raw) return null;
  const value = raw.trim();
  if (!value.startsWith("/") || value.startsWith("//")) return null;
  if (value.startsWith("/sign-up-login-screen")) return null;
  return value.slice(0, 1000);
}

export function authRedirectTarget(search: string | URLSearchParams): string {
  const params = typeof search === "string"
    ? new URLSearchParams(search.startsWith("?") ? search.slice(1) : search)
    : search;

  const explicitReturn = safeReturnTarget(params.get("returnTo"));
  if (explicitReturn) return explicitReturn;

  const pair = (params.get("pair") || "").toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 8);
  if (pair) return `/our-space?pair=${encodeURIComponent(pair)}`;

  const shared = params.get("shared");
  const roomId = params.get("roomId");
  const code = params.get("code");
  if (shared || roomId || code) {
    const target = new URLSearchParams();
    if (shared) target.set("shared", shared.slice(0, 180));
    if (roomId) target.set("roomId", roomId.slice(0, 180));
    if (code) target.set("code", code.slice(0, 24));
    const ref = params.get("ref");
    if (ref) target.set("ref", ref.slice(0, 24));
    return `/watch-room?${target.toString()}`;
  }

  return "/dashboard";
}

export function authUrlForProtectedRoute(pathname: string, search: string): string {
  const target = safeReturnTarget(`${pathname}${search}`) || "/dashboard";
  const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  params.set("returnTo", target);
  return `/sign-up-login-screen?${params.toString()}`;
}
